import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getCookie, setCookie } from '@beef/utils';
import { Accumulator, AccumulatorList, ReplenishmentButton, dispatchHideGiftAccumulatorEvent, getAccumulatorTextContent, getAccumulatorVariant } from '@beef/elk-common';
import { useCustomEvent } from '@beef/elk-common/hooks';
import { getHasGiftAccumulator } from "../../../../../utils/accumulators";
import { Metric } from "../../../../../utils/metric";
import { selectAccountType, selectIsProstoy, selectIsSvyazZ, selectTariffLink } from "../../store/selectors";
import { selectMobileConnectionAccumulators } from "../MobileTariff/store";
import { GIFT_VIEW_COOKIE } from "../../constants/accumulators";
var _Accumulators = function _Accumulators(_ref) {
  var accumulators = _ref.accumulators,
    tariffUrl = _ref.tariffUrl,
    isProstoy = _ref.isProstoy,
    isSvyazZ = _ref.isSvyazZ,
    userType = _ref.userType;
  var TextContentComponent = getAccumulatorTextContent(getAccumulatorVariant({
    isProstoy: isProstoy,
    isSvyazZ: isSvyazZ
  }));
  useEffect(function () {
    var hasGiftAccum = getHasGiftAccumulator(accumulators);
    var hasGiftCookie = getCookie(GIFT_VIEW_COOKIE);
    if (!hasGiftCookie && hasGiftAccum) {
      setCookie({
        name: GIFT_VIEW_COOKIE,
        value: 'true'
      });
    }
  }, []);
  var hasGiftAccum = getHasGiftAccumulator(accumulators);
  var _useState = useState(getCookie(GIFT_VIEW_COOKIE) === 'true'),
    _useState2 = _slicedToArray(_useState, 2),
    showGiftAccum = _useState2[0],
    setShowGiftAccum = _useState2[1];
  useCustomEvent('showGiftAccumulator', setShowGiftAccum);
  var handleIconCloseClick = function handleIconCloseClick(e) {
    e.preventDefault();
    setShowGiftAccum(false);
    setCookie({
      name: GIFT_VIEW_COOKIE,
      value: 'false'
    });
    dispatchHideGiftAccumulatorEvent();
  };
  return /*#__PURE__*/React.createElement(AccumulatorList, {
    accumulators: accumulators,
    handleIconCloseClick: handleIconCloseClick,
    hasGiftAccum: hasGiftAccum,
    showGiftAccum: showGiftAccum,
    "data-t-id": "components-Accumulators"
  }, function (_ref2) {
    var accumulator = _ref2.accumulator,
      isInline = _ref2.isInline;
    return /*#__PURE__*/React.createElement(Accumulator, {
      accumulator: accumulator,
      buttonSlot: /*#__PURE__*/React.createElement(Metric, {
        data: JSON.stringify({
          userType: userType
        }),
        events: {
          fubMetricSideMenu: ['handleAddTrafficClick']
        },
        mode: "click"
      }, /*#__PURE__*/React.createElement(ReplenishmentButton, {
        isSvyazZ: isSvyazZ,
        replenishButtonType: accumulator.replenishButtonType,
        shouldRender: !!accumulator.replenishButtonType,
        tariffUrl: tariffUrl,
        "data-t-id": "components-Accumulators"
      })),
      hideProgress: accumulator.size === undefined || accumulator.isUnlimited,
      isInline: isInline,
      isMobile: true
    }, /*#__PURE__*/React.createElement(TextContentComponent, {
      accumulator: accumulator,
      isInline: isInline,
      isMobile: true
    }));
  });
};
var mapStateToProps = function mapStateToProps(state) {
  var accumulators = selectMobileConnectionAccumulators(state);
  return {
    accumulators: accumulators,
    tariffUrl: selectTariffLink(state),
    isSvyazZ: selectIsSvyazZ(state),
    isProstoy: selectIsProstoy(state),
    userType: selectAccountType(state),
    shouldRender: !!accumulators.length
  };
};
var connector = connect(mapStateToProps);
export var Accumulators = connector(_Accumulators);